import React, { useState, useEffect, useRef, useCallback } from 'react';

const Carousel = ({ event }) => {
  return (
    <>
      {event.gallery?.length > 0 && (
        <>
          <div className='carousel w-full'>
            {event.gallery.map((link, Index) => (
              <div id={'item' + Index} className='carousel-item w-full items-center justify-center'>
                <img src={link} className='w-1/3' />
              </div>
            ))}
          </div>

          <div className='flex justify-center w-full py-2 gap-2'>
            {event.gallery.map((link, Index) => (
              <a href={'#item' + Index} className='btn btn-xs'>
                {Index + 1}
              </a>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Carousel;
